import React from 'react';

import PropTypes from 'prop-types';

import { withContext, getContext } from 'recompose';

export class IDGenerator {
  constructor() {
    this._counter = 0;
  }

  next(): number {
    this._counter++;
    return this._counter;
  }
}

const provideIdGenerator = withContext(
  { idGenerator: React.PropTypes.object },
  () => ({ idGenerator: new IDGenerator() }),
);

const withIdGenerator = getContext({ idGenerator: PropTypes.object });

export { withIdGenerator };
export default provideIdGenerator;



// WEBPACK FOOTER //
// ../src/client/UniqueIdProvider.js